<script>
import Settings from "./admin/Settings.vue";

export default {
  name: "AdminApp",
  components: { Settings }
}
</script>

<template>
<Settings></Settings>
</template>

<style scoped lang="less">

</style>